import { render, staticRenderFns } from "./AgreementView.vue?vue&type=template&id=0232461a&scoped=true&"
import script from "./AgreementView.vue?vue&type=script&lang=js&"
export * from "./AgreementView.vue?vue&type=script&lang=js&"
import style0 from "./AgreementView.vue?vue&type=style&index=0&id=0232461a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0232461a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0232461a', component.options)
    } else {
      api.reload('0232461a', component.options)
    }
    module.hot.accept("./AgreementView.vue?vue&type=template&id=0232461a&scoped=true&", function () {
      api.rerender('0232461a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/AgreementView.vue"
export default component.exports